import { render, staticRenderFns } from "./doubleFragmentTable.vue?vue&type=template&id=99a7a7f0&scoped=true"
import script from "./doubleFragmentTable.vue?vue&type=script&lang=js"
export * from "./doubleFragmentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a7a7f0",
  null
  
)

export default component.exports